import { RouteConfig } from 'vue-router';

const ModeView = () => import('@/views/mode.vue');

export default {
  path: '/mode',
  name: 'mode',
  component: ModeView,
  meta: {
    layout: 'auth',
  },
} as RouteConfig;
